import { add, divide, subtract } from 'utils/generic/calculator';

export const singlEachwayCalc = (coef: number, eachWayK: number): number => {
  return +add(divide(subtract(coef, 1), eachWayK), 1);
};
